import React from "react";
export const SvgComponent = ({ title, handlePlate, ...props }) => {

    return (

        <div className="svgContainer">
            <h2>{title}</h2>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 798.16 860.92"
                {...props}
            >
                <defs>
                    <style>
                        {
                            ".cls-1 {fill: #fff;}.cls-1, .cls-2 {stroke: #000;  stroke-miterlimit: 10;}.cls-2 {fill: none;}"
                        }
                    </style>
                </defs>
                <g>
                    <line className="cls-2" x1={686.88} y1={860.92} x2={688.08} y2={85.55} />
                    <path d="m687.36,89.84c-.16.63.81.89.98.25.3-1.24.63-2.48.97-3.71,2.6-9.32,6.39-18.31,11.33-26.63,4.5-7.59,9.95-14.6,16.23-20.79,5.96-5.87,12.66-10.95,19.95-15.05,9.41-5.29,19.62-8.96,30.07-11.6,10.17-2.56,20.55-4.19,30.91-5.8.63-.09.36-1.06-.27-.96-1.29.2-2.58.4-3.87.6-10.48,1.65-20.96,3.44-31.19,6.31-10.36,2.9-20.43,6.95-29.6,12.62-6.99,4.33-13.4,9.62-19.06,15.58-6.16,6.49-11.46,13.78-15.77,21.61-4.78,8.66-8.33,17.97-10.68,27.57h0Z" />
                </g>
                <g id="Capa_3" data-name="Capa 3">
                    <path
                        className="cls-1"
                        d="m134.86,811.44c.6,0,1.17.04,1.67.12h480.03c9.43-2.56,16.74-6.94,17.01-15.64.01-.71.23-1.34.59-1.88v-327.08c-3.96-6.8-13.2-13.11-23.07-16.84H145.35c-.78.24-1.71.37-2.77.35-7.57-.14-14.36.71-18.64,5.45-2.01,2.21-3.36,4.74-4.43,7.34v339.8c3.11,4.51,7.41,8.51,15.35,8.39h0Z"
                    />
                    <ellipse className="cls-1" cx={610.09} cy={463.85} rx={7.68} ry={5.39} />
                    <ellipse className="cls-1" cx={142.64} cy={463.85} rx={7.68} ry={5.39} />
                    <ellipse className="cls-1" cx={610.09} cy={798.57} rx={7.68} ry={5.39} />
                    <ellipse className="cls-1" cx={142.64} cy={798.57} rx={7.68} ry={5.39} />
                </g>
                <g id="Capa_4" data-name="Capa 4">
                    <g>
                        <line className="cls-2" x1={607.19} y1={741.4} x2={634.1} y2={741.4} />
                        <line
                            className="cls-2"
                            x1={607.19}
                            y1={735.85}
                            x2={607.19}
                            y2={741.4}
                        />
                        <line
                            className="cls-2"
                            x1={634.1}
                            y1={728.18}
                            x2={607.19}
                            y2={735.85}
                        />
                        <line
                            className="cls-2"
                            x1={607.04}
                            y1={749.82}
                            x2={633.94}
                            y2={749.82}
                        />
                        <line
                            className="cls-2"
                            x1={607.04}
                            y1={755.36}
                            x2={607.04}
                            y2={749.82}
                        />
                        <line
                            className="cls-2"
                            x1={633.94}
                            y1={763.04}
                            x2={607.04}
                            y2={755.36}
                        />
                        <line
                            className="cls-2"
                            x1={607.12}
                            y1={679.04}
                            x2={634.02}
                            y2={679.04}
                        />
                        <line
                            className="cls-2"
                            x1={607.12}
                            y1={673.49}
                            x2={607.12}
                            y2={679.04}
                        />
                        <line
                            className="cls-2"
                            x1={634.02}
                            y1={665.82}
                            x2={607.12}
                            y2={673.49}
                        />
                        <line
                            className="cls-2"
                            x1={606.97}
                            y1={687.46}
                            x2={633.88}
                            y2={687.46}
                        />
                        <line
                            className="cls-2"
                            x1={606.97}
                            y1={693.01}
                            x2={606.97}
                            y2={687.46}
                        />
                        <line
                            className="cls-2"
                            x1={633.88}
                            y1={700.68}
                            x2={606.97}
                            y2={693.01}
                        />
                        <line className="cls-2" x1={607.12} y1={618.5} x2={634.02} y2={618.5} />
                        <line
                            className="cls-2"
                            x1={607.12}
                            y1={612.95}
                            x2={607.12}
                            y2={618.5}
                        />
                        <line
                            className="cls-2"
                            x1={634.02}
                            y1={605.28}
                            x2={607.12}
                            y2={612.95}
                        />
                        <line
                            className="cls-2"
                            x1={606.97}
                            y1={626.92}
                            x2={633.88}
                            y2={626.92}
                        />
                        <line
                            className="cls-2"
                            x1={606.97}
                            y1={632.47}
                            x2={606.97}
                            y2={626.92}
                        />
                        <line
                            className="cls-2"
                            x1={633.88}
                            y1={640.14}
                            x2={606.97}
                            y2={632.47}
                        />
                        <line
                            className="cls-2"
                            x1={607.12}
                            y1={557.95}
                            x2={634.02}
                            y2={557.95}
                        />
                        <line
                            className="cls-2"
                            x1={607.12}
                            y1={552.4}
                            x2={607.12}
                            y2={557.95}
                        />
                        <line
                            className="cls-2"
                            x1={634.02}
                            y1={544.73}
                            x2={607.12}
                            y2={552.4}
                        />
                        <line
                            className="cls-2"
                            x1={606.97}
                            y1={566.37}
                            x2={633.88}
                            y2={566.37}
                        />
                        <line
                            className="cls-2"
                            x1={606.97}
                            y1={571.92}
                            x2={606.97}
                            y2={566.37}
                        />
                        <line
                            className="cls-2"
                            x1={633.88}
                            y1={579.59}
                            x2={606.97}
                            y2={571.92}
                        />
                        <line
                            className="cls-2"
                            x1={607.26}
                            y1={498.16}
                            x2={634.16}
                            y2={498.16}
                        />
                        <line
                            className="cls-2"
                            x1={607.26}
                            y1={492.61}
                            x2={607.26}
                            y2={498.16}
                        />
                        <line
                            className="cls-2"
                            x1={634.16}
                            y1={484.94}
                            x2={607.26}
                            y2={492.61}
                        />
                        <line
                            className="cls-2"
                            x1={607.12}
                            y1={506.58}
                            x2={634.02}
                            y2={506.58}
                        />
                        <line
                            className="cls-2"
                            x1={607.12}
                            y1={512.12}
                            x2={607.12}
                            y2={506.58}
                        />
                        <line
                            className="cls-2"
                            x1={634.02}
                            y1={519.8}
                            x2={607.12}
                            y2={512.12}
                        />
                        <line
                            className="cls-2"
                            x1={146.48}
                            y1={742.52}
                            x2={119.59}
                            y2={742.52}
                        />
                        <line
                            className="cls-2"
                            x1={146.48}
                            y1={736.97}
                            x2={146.48}
                            y2={742.52}
                        />
                        <line
                            className="cls-2"
                            x1={119.59}
                            y1={729.3}
                            x2={146.48}
                            y2={736.97}
                        />
                        <line
                            className="cls-2"
                            x1={146.64}
                            y1={750.94}
                            x2={119.73}
                            y2={750.94}
                        />
                        <line
                            className="cls-2"
                            x1={146.64}
                            y1={756.49}
                            x2={146.64}
                            y2={750.94}
                        />
                        <line
                            className="cls-2"
                            x1={119.73}
                            y1={764.16}
                            x2={146.64}
                            y2={756.49}
                        />
                        <line
                            className="cls-2"
                            x1={146.56}
                            y1={680.16}
                            x2={119.67}
                            y2={680.16}
                        />
                        <line
                            className="cls-2"
                            x1={146.56}
                            y1={674.61}
                            x2={146.56}
                            y2={680.16}
                        />
                        <line
                            className="cls-2"
                            x1={119.67}
                            y1={666.94}
                            x2={146.56}
                            y2={674.61}
                        />
                        <line
                            className="cls-2"
                            x1={146.7}
                            y1={688.58}
                            x2={119.81}
                            y2={688.58}
                        />
                        <line className="cls-2" x1={146.7} y1={694.13} x2={146.7} y2={688.58} />
                        <line className="cls-2" x1={119.81} y1={701.8} x2={146.7} y2={694.13} />
                        <line
                            className="cls-2"
                            x1={146.56}
                            y1={619.62}
                            x2={119.67}
                            y2={619.62}
                        />
                        <line
                            className="cls-2"
                            x1={146.56}
                            y1={614.07}
                            x2={146.56}
                            y2={619.62}
                        />
                        <line
                            className="cls-2"
                            x1={119.67}
                            y1={606.4}
                            x2={146.56}
                            y2={614.07}
                        />
                        <line
                            className="cls-2"
                            x1={146.7}
                            y1={628.04}
                            x2={119.81}
                            y2={628.04}
                        />
                        <line className="cls-2" x1={146.7} y1={633.59} x2={146.7} y2={628.04} />
                        <line
                            className="cls-2"
                            x1={119.81}
                            y1={641.26}
                            x2={146.7}
                            y2={633.59}
                        />
                        <line
                            className="cls-2"
                            x1={146.56}
                            y1={559.07}
                            x2={119.67}
                            y2={559.07}
                        />
                        <line
                            className="cls-2"
                            x1={146.56}
                            y1={553.52}
                            x2={146.56}
                            y2={559.07}
                        />
                        <line
                            className="cls-2"
                            x1={119.67}
                            y1={545.85}
                            x2={146.56}
                            y2={553.52}
                        />
                        <line
                            className="cls-2"
                            x1={146.7}
                            y1={567.49}
                            x2={119.81}
                            y2={567.49}
                        />
                        <line className="cls-2" x1={146.7} y1={573.04} x2={146.7} y2={567.49} />
                        <line
                            className="cls-2"
                            x1={119.81}
                            y1={580.71}
                            x2={146.7}
                            y2={573.04}
                        />
                        <line
                            className="cls-2"
                            x1={146.42}
                            y1={499.28}
                            x2={119.51}
                            y2={499.28}
                        />
                        <line
                            className="cls-2"
                            x1={146.42}
                            y1={493.73}
                            x2={146.42}
                            y2={499.28}
                        />
                        <line
                            className="cls-2"
                            x1={119.51}
                            y1={486.06}
                            x2={146.42}
                            y2={493.73}
                        />
                        <line className="cls-2" x1={146.56} y1={507.7} x2={119.67} y2={507.7} />
                        <line
                            className="cls-2"
                            x1={146.56}
                            y1={513.25}
                            x2={146.56}
                            y2={507.7}
                        />
                        <line
                            className="cls-2"
                            x1={119.67}
                            y1={520.92}
                            x2={146.56}
                            y2={513.25}
                        />
                    </g>
                </g>
                <g id="Capa_5" data-name="Capa 5">
                    <rect
                    onClick={e => handlePlate(e)}
                        className="cls-2"
                        x={147.63}
                        y={741.4}
                        width={459.34}
                        height={9.54}
                    />
                    <rect
                    onClick={e => handlePlate(e)}
                        className="cls-2"
                        x={147.63}
                        y={678.48}
                        width={459.34}
                        height={9.54}
                    />
                    <rect
                    onClick={e => handlePlate(e)}
                        className="cls-2"
                        x={146.56}
                        y={619.06}
                        width={459.34}
                        height={9.54}
                    />
                    <rect
                    onClick={e => handlePlate(e)}
                        className="cls-2"
                        x={146.56}
                        y={558.51}
                        width={459.34}
                        height={9.54}
                    />
                    <rect
                    onClick={e => handlePlate(e)}
                        className="cls-2"
                        x={147.63}
                        y={497.6}
                        width={459.34}
                        height={9.54}
                    />
                </g>
                <rect
                    className="cls-1"
                    x={584.84}
                    y={138.98}
                    width={102.64}
                    height={237.33}
                    transform="translate(1272.32 515.3) rotate(-180)"
                />
                <path
                    className="cls-1"
                    d="m46.18,423.96V35.2c2.83-3.41,6.02-6.56,9.32-9.55h529.34v404.81H50.51c-1.51-2.13-2.98-4.28-4.33-6.5Z"
                />
                <circle className="cls-1" cx={63.24} cy={228.06} r={9.87} />
            </svg>

        </div>
    )
}